import { Component, Inject } from '@angular/core';
import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { NgClass } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-cancel-confirmation',
	templateUrl: './cancel-confirmation.component.html',
	styleUrls: [
		'./cancel-confirmation.component.scss',
		'../../ui/common/main.scss',
	],
	imports: [
		MatDialogTitle,
		NgClass,
		CdkScrollable,
		MatDialogContent,
		MatDialogActions,
		MatButton,
	],
})
export class CancelConfirmationComponent {
	dialogHeader: string;
	dialogContent: string;
	dialogSecondaryHeader?: string;
	dialogSecondaryContent?: string;
	dialogListedItemContent?: string[];
	dialogPrimaryButtonText?: string;
	dialogSecondaryButtonText?: string;
	showDevider?: boolean;
	useSmallButtons?: boolean;
	useWarningStyle?: boolean;
	useCompactStyle?: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: {
			dialogHeader: string;
			dialogContent: string;
			dialogSecondaryHeader?: string;
			dialogSecondaryContent?: string;
			dialogListedItemContent?: string[];
			dialogPrimaryButtonText: string;
			dialogSecondaryButtonText: string;
			primaryFunction?: any;
			secondaryFunction?: any;
			showDevider?: boolean;
			useSmallButtons?: boolean;
			useWarningStyle?: boolean;
			useCompactStyle?: boolean;
		},
		private readonly dialogRef: MatDialogRef<CancelConfirmationComponent>
	) {
		this.dialogHeader = data.dialogHeader;
		this.dialogContent = data.dialogContent;
		this.dialogSecondaryHeader = data?.dialogSecondaryHeader;
		this.dialogSecondaryContent = data?.dialogSecondaryContent;
		this.dialogListedItemContent = data?.dialogListedItemContent ?? [];
		this.dialogPrimaryButtonText = data.dialogPrimaryButtonText;
		this.dialogSecondaryButtonText = data.dialogSecondaryButtonText;
		this.showDevider = data.showDevider ?? false;
		this.useSmallButtons = data.useSmallButtons ?? false;
		this.useWarningStyle = data.useWarningStyle ?? false;
		this.useCompactStyle = data.useCompactStyle ?? false;
	}

	onPrimaryButtonClicked(): void {
		this.dialogRef.close();
		if (this.data.primaryFunction) {
			this.data.primaryFunction();
		}
	}

	onSecondaryButtonClicked(): void {
		this.dialogRef.close();
		if (this.data.secondaryFunction) {
			this.data.secondaryFunction();
		}
	}
}
